import React from "react";
import MenuItem from "../Menu/MenuItem";
import {SideMenuWrapper} from "./Index";
import {SIDEMENU} from "Framework/consts/menuTypes";

const SideMenu = (props) => {
	let depth = 1;
	return (
		<SideMenuWrapper role="navigation">
			<MenuItem
				LastItem={true}
				Depth={depth}
				{...props}
				Display={props.Children.length > 0}
				MenuType={SIDEMENU}
			/>
		</SideMenuWrapper>
	);
};

export default SideMenu;
